import FullCalendar from "@fullcalendar/react";
import BootstrapTheme from "@fullcalendar/bootstrap";
import "@fullcalendar/bootstrap/main.css";
import esLocale from "@fullcalendar/core/locales/es-us";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import moment from 'moment';
import React from 'react';
import { Card, CardBody, Col, Container, Label, Modal, CardTitle, ModalBody, ModalFooter, ModalHeader, Row, Spinner } from 'reactstrap';
import Select from 'react-select';
import toastr from "toastr";
import ApiRest from "../../ayudas/apiRest";
import Breadcrumbs from '../../components/Common/Breadcrumb';
import _valid from "../../validations";
import SolicitudInformacion from "../informacion/solicitudInformacion";
import { SOLICITUD_ESTADOS, noMasOpciones, noMasOpciones2 } from "../../ayudas/constantes";
import { MDBBtn, MDBDataTable, MDBIcon } from "mdbreact";
import ProyectoSolicitudInformacion from '../../paginas/informacion/proyectoSolicitudInformacion';



export default class Calendario extends React.Component {

    constructor(props) {
        super(props)
        this.apiRest = new ApiRest(props);

        this.state = {
            estadoModal: false,
            mostrarSpinner: true,
            registro: {},
            eventos: [],

            tipo_solicitud: undefined,
            asignado_a: undefined,
            solicitar_a: undefined,
            depto_solicita: undefined,
            lugar_ubicacion: undefined,
            estado: undefined,

            tiposSolicitudes: [],
            asignado_a_listado: [],
            departamentosAreas: [],
            ubicaciones: [],
            estados: SOLICITUD_ESTADOS,

            filtros: {
                fechaMin: moment().clone().startOf('month').format('YYYY-MM-DD'),
                fechaFin: moment().clone().endOf('month').format('YYYY-MM-DD'),
                empresa: undefined,
                usuario: undefined
            }
        }

        this.controladorModal = this.controladorModal.bind(this);
        this.controladorClicks = this.controladorClicks.bind(this);
        this.actualizarFechasAlCambiarMes = this.actualizarFechasAlCambiarMes.bind(this);
        this.actualizarDatosTipoSolicitud = this.actualizarDatosTipoSolicitud.bind(this);
        this.actualizarSelectsYDatosPorFiltros = this.actualizarSelectsYDatosPorFiltros.bind(this);
    }

    componentDidMount() {
        // Filtra por el inicio y fin del mes actual
        //this.actualizarDatosEnCalendario(this.state.filtros);
        this.cargarListado();
        //this.consultaPersonalizada(this.state.filtros);
    }

    actualizarFechasAlCambiarMes(e) {
        if (e.view.type === 'dayGridMonth') {
            let mesActual = moment(e.endStr).clone().subtract(1, "month");
            this.setState(
                anterior => (
                    {
                        ...anterior,
                        filtros: {
                            ...anterior.filtros,
                            fechaMin: mesActual.startOf('month').format('YYYY-MM-DD'),
                            fechaFin: mesActual.endOf('month').format('YYYY-MM-DD')
                        }
                    }
                ),
                () => this.actualizarDatosEnCalendario(this.state.filtros)
            );
        }

        if (e.view.type === 'dayGridWeek') {
            let mesActual = moment(e.endStr).clone().subtract(0, "month");
            let fechaLunes = mesActual.startOf('isoWeek');
            this.setState(
                anterior => (
                    {
                        ...anterior,
                        filtros: {
                            ...anterior.filtros,
                            fechaMin: fechaLunes.clone().subtract(1, 'days').format('YYYY-MM-DD'),
                            fechaFin: fechaLunes.clone().add(5, 'days').format('YYYY-MM-DD')
                        }
                    }
                ),
                () => this.actualizarDatosEnCalendario(this.state.filtros)
            );
        }

        if (e.view.type === 'dayGridDay') {
            let mesActual = moment(e.endStr).clone().subtract(0, "month");
            let fechaHoy = mesActual.startOf('day');
            this.setState(
                anterior => (
                    {
                        ...anterior,
                        filtros: {
                            ...anterior.filtros,
                            fechaMin: fechaHoy.clone().subtract(1, 'days').format('YYYY-MM-DD'),
                            fechaFin: fechaHoy.clone().subtract(1, 'days').format('YYYY-MM-DD')
                        }
                    }
                ),
                () => this.actualizarDatosEnCalendario(this.state.filtros)
            );
        }

    }

    actualizarDatosTipoSolicitud(valores, { name }) {
        this.setState(
            anterior => (
                {
                    ...anterior,
                    filtros: {
                        ...anterior.filtros,
                        [name]: valores
                    }
                }
            ),
            //() => this.actualizarDatosEnCalendario(this.state.filtros)
        );

        if (_valid(valores)) {
            this.getTipoSolicitud(valores.value);
            if (!this.apiRest.getRol()) {
                this.colaboradorListado(valores.value);
            }
        } else {
            this.setState({ tiposSolicitudes: [] });
            if (!this.apiRest.getRol()) {
                this.setState({ asignado_a_listado: [] });
            }
        }
    }

    colaboradorListado(id) {
        this.apiRest.get('/colaboradorDepartamentoArea').then(respuesta => {
            if (respuesta.exitoso) {
                this.setState({ asignado_a_listado: respuesta.data });
            }
        });
    }

    getTipoSolicitud = (id) => {
        //obtener tipo de solicitudes
        this.apiRest.get('/tipoSolicitudPorDepartamento/' + id).then(respuesta => {
            if (respuesta.exitoso) {
                this.setState({ tiposSolicitudes: this.formatoSelect(respuesta) });
            }
        });
    }

    actualizarSelectsYDatosPorFiltros = (valores, { name }) => {
        this.setState(
            anterior => (
                {
                    ...anterior,
                    [name]: valores,
                    filtros: _valid(valores) ?
                        { ...anterior.filtros, [name]: valores }
                        :
                        (delete anterior.filtros[name] && { ...anterior.filtros })
                }
            ),
            //() => this.actualizarDatosEnCalendario(this.state.filtros)
        );
    }

    actualizarDatosEnCalendario(filtros) {
        console.log(filtros);
        filtros.esCalendario = true;
        this.setState({ mostrarSpinner: true });
        this.consulta(filtros);
        /*if (this.apiRest.getRol() == false) {
            if (_valid(this.apiRest.getRolDeUsuario('ROL_RESPONSABLE_DEPARTAMENTO'))) {
                filtros.empresa = this.apiRest.getLS('idEmpresa').id;
                //this.consultaPersonalizada(filtros);
                this.consulta(filtros);
            } else {
                filtros.empresa = this.apiRest.getLS('idEmpresa').id;
                filtros.usuario = this.apiRest.getLS('du').colaborador.id
                this.consulta(filtros);
            }
        } else {
            this.consulta(filtros);
        }*/

    }

    consultaPersonalizada(filtros) {
        this.apiRest.misSolicitudes('/administradorDepartamento', filtros).then(respuesta => {
            if (respuesta.exitoso) {

                let data = _valid(respuesta.data[0]) ? respuesta.data[0] : [];

                const eventos = data.map(e => {
                    let fecha;
                    if (!_valid(e.fecha_programada, e.fecha_fin)) {
                        fecha = new Date(moment(e.fecha_creacion).clone().add(1, "day").format("YYYY-MM-DD"));
                    } else {
                        fecha = new Date(moment(e.fecha_programada).clone().add(1, "day").format("YYYY-MM-DD"));
                        e["end"] = new Date(moment(e.fecha_fin).clone().add(1, "day").format("YYYY-MM-DD"));
                    }
                    fecha.setHours(parseInt(e.horas));
                    let minutos = parseInt(e.minutos);
                    if (minutos === 1) {
                        minutos = 15;
                    } else {
                        minutos = (minutos === 2) ? 30 : 45;
                    }
                    fecha.setMinutes(minutos);
                    e["start"] = fecha;
                    return e;
                });
                this.setState({ mostrarSpinner: false, eventos });
            } else {
                toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
                this.setState({ mostrarSpinner: false });
            }
        });
    }

    consulta = (filtros) => {
        //console.log(filtros)
        //url = '/solicitudesFiltradas'
        this.apiRest.post('/solicitudCalendarioFiltrar', filtros).then(respuesta => {
            if (respuesta.exitoso) {
                const eventos = respuesta.data.map(e => {
                    //console.log(_valid(e.fecha_programada, e.fecha_fin));
                    let fecha;
                    fecha = new Date(moment(e.fecha_programada).clone().add(1, "day").format("YYYY-MM-DD"));
                    fecha.setHours(0);
                    /*if (!_valid(e.fecha_programada, e.fecha_fin)) {
                        fecha = new Date(moment(e.fecha_programada).clone().add(1, "day").format("YYYY-MM-DD"));
                    /*} else {
                        fecha = new Date(moment(e.fecha_programada).clone().add(1, "day").format("YYYY-MM-DD"));
                        e["end"] = new Date(moment(e.fecha_fin).clone().add(1, "day").format("YYYY-MM-DD"));
                    }
                    fecha.setHours(parseInt(e.horas));
                    let minutos = parseInt(e.minutos);
                    if (minutos === 1) {
                        minutos = 15;
                    } else {
                        minutos = (minutos === 2) ? 30 : 45;
                    }
                    fecha.setMinutes(minutos);*/                    
                    e["start"] = fecha;
                    return e;
                });
                this.setState({ mostrarSpinner: false, eventos });
            } else {
                toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
                this.setState({ mostrarSpinner: false });
            }
        });
    }

    controladorModal = registro => {
        if (_valid(registro)) {
            this.setState(anterior => ({ ...anterior, registro, estadoModal: !anterior.estadoModal }));
        } else {
            this.setState(anterior => ({ ...anterior, estadoModal: !anterior.estadoModal }));
        }
    }

    controladorClicks = arg => {
        let evento = arg.event.toJSON();
        let datosRegistro = { ...evento.extendedProps, id: parseInt(evento["id"]) };
        this.controladorModal(datosRegistro);
    }


    formatoSelect = valores => valores.data.map(i => ({ value: i.id, label: i.nombre || i.nombres }));
    formatoColaborador = valores => valores.data.map(i => ({ value: i.id, label: i.nombres + ' ' + i.apellidos }));
    formatoColaboradorPorDepartamento = valores => valores.map(i => ({ value: i.value, label: i.label }));
    formatoArea = valores => valores.data.map(i => ({ value: i.id_departamento, label: i.departamento }));
    formatoSelectUbiciacion = valores => valores.data.map(i => ({ value: i.id, label: i.ubicacion_texto }));

    cargarListado = () => {
        /*if (this.apiRest.getRol()) {
            this.datosAdministrador();
        } else {
            if (_valid(this.apiRest.getLS('idEmpresa'))) {
                this.datosPorEmpresa(this.apiRest.getLS('idEmpresa').id);
            }
        }*/
        this.datosAdministrador();
    }

    datosPorEmpresa = () => {
        let hayError = false;
        let id = null;
        id = this.apiRest.getLS('du').colaborador.id;

        this.obtenerDepartamentoLoggeado(id);

        /*this.apiRest.getColaborador('/getColaborador/').then(respuesta => {
            if (respuesta.exitoso) {
                this.setState({ asignado_a_listado: this.formatoColaborador(respuesta) });
            } else {
                hayError = true;
            }
        });*/

        this.apiRest.getUbicacion('/getUbicacion/').then(respuesta => {
            if (respuesta.exitoso) {
                this.setState({ ubicaciones: this.formatoSelectUbiciacion(respuesta) });
            } else {
                hayError = true;
            }
        });

        /*this.apiRest.getTipoDeSolicitud('/getTipoSolicitud/').then(respuesta => {
            if (respuesta.exitoso) {
                this.setState({ tiposSolicitudes: this.formatoSelect(respuesta) });
            } else {
                hayError = true;
            }
        });*/
    }

    obtenerDepartamentoLoggeado = (id) => {
        if (_valid(id)) {
            this.apiRest.get('/departamentoLoggeado/' + id).then(respuesta => {
                if (respuesta.exitoso) {
                    this.setState({ departamentosAreas: this.formatoArea(respuesta) });
                }
            });
        }
    }

    datosAdministrador = () => {
        let hayError = false;

        this.apiRest.get('/departamentoArea').then(resultado => {
            if (resultado.exitoso) {
                this.setState({ departamentosAreas: resultado.data });
            } else {
                hayError = true;
            }
        });

        this.apiRest.get('/ubicacion').then(resultado => {
            if (resultado.exitoso) {
                this.setState({ ubicaciones: this.formatoSelectUbiciacion(resultado) });
            } else {
                hayError = true;
            }
        });

        this.apiRest.get('/colaboradorDepartamentoArea').then(respuesta => {
            if (respuesta.exitoso) {
                this.setState({ asignado_a_listado: respuesta.data });
            } else {
                hayError = true;
            }
        });

        if (hayError) {
            toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
        }
        this.setState({ mostrarSpinner: false });
    }

    filtrarBusqueda = () => {
        this.actualizarDatosEnCalendario(this.state.filtros);
    }

    getReport = () => {
        const {
            eventos
        } = this.state
        let array = null;
        if (_valid(eventos)) {
            array = eventos
        }
        if (_valid(array)) {
            this.reporte(array)
        } else {
            toastr.error('Busque Primero la Informacion que quiere Exportar a Excel');
        }
    }

    //reporte de solicitudes
    reporte = (datos) => {
        if (_valid(datos)) {
            const auth = this.apiRest.getLS('authUser');
            if (auth !== null) {
                const headers = {
                    method: 'PUT',
                    headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + auth.access },
                    responseType: 'blob',
                    body: JSON.stringify(datos ? datos : '')
                }
                fetch(process.env.REACT_APP_API_URL + "/reporteExcelCalendario", headers).then(resp => {
                    if (resp.status >= 200 && resp.status < 300) {
                        resp.blob().then(blob => {
                            const url = window.URL.createObjectURL(blob);
                            const a = document.createElement("a");
                            a.style.display = "none";
                            a.href = url;
                            // the filename you want
                            a.download = "reporte.xlsx";
                            document.body.appendChild(a);
                            a.click();
                            window.URL.revokeObjectURL(url);
                        });
                    } else if (resp.status === 401) {
                        this.props.history.push('/Timeout');
                    }
                });
            } else {
                toastr.error('Vaya! No loggeado, por favor intenta nuevamente.');
            }
        } else {
            toastr.error('No hay datos para procesar');
        }
    }

    render() {
        const {
            mostrarSpinner,
            estadoModal,
            eventos,
            registro,

            tipo_solicitud,
            asignado_a,
            solicitar_a, /*Area*/
            depto_solicita,
            lugar_ubicacion,
            estado,

            tiposSolicitudes,
            asignado_a_listado,
            departamentosAreas,
            ubicaciones,
            estados,

        } = this.state;

        return (
            <React.Fragment>
                <Card>
                    <CardBody>
                        <div className="page-content">                            
                            <Card>
                                <CardBody>
                                    <Row>
                                        {
                                            (this.apiRest.getRolDeUsuario('ROL_ADMIN') || this.apiRest.getRolDeUsuario('ROL_RESPONSABLE_DEPARTAMENTO')) ?
                                                <Col lg={4}>
                                                    <Label htmlFor="solicitar_a" className="form-label">
                                                        Recibidas por el Departamento
                                                    </Label>
                                                    <Select
                                                        name="solicitar_a"
                                                        options={departamentosAreas}
                                                        value={solicitar_a}
                                                        onChange={this.actualizarDatosTipoSolicitud}
                                                        className="basic-single"
                                                        classNamePrefix="select"
                                                        placeholder="Selecciona.."
                                                        isClearable={true}
                                                        isSearchable={true}
                                                        noOptionsMessage={noMasOpciones}
                                                    />
                                                </Col>
                                            : ""
                                        }
                                        {
                                            (this.apiRest.getRolDeUsuario('ROL_ADMIN') || !this.apiRest.getRolDeUsuario('ROL_RESPONSABLE_DEPARTAMENTO')) ?
                                                <Col lg={4}>
                                                    <Label htmlFor="depto_solicita" className="form-label">
                                                        Enviadas por el Departamento
                                                    </Label>
                                                    <Select
                                                        name="depto_solicita"
                                                        options={departamentosAreas}
                                                        value={depto_solicita}
                                                        onChange={this.actualizarSelectsYDatosPorFiltros}
                                                        className="basic-single"
                                                        classNamePrefix="select"
                                                        placeholder="Selecciona.."
                                                        isClearable={true}
                                                        isSearchable={true}
                                                        noOptionsMessage={noMasOpciones}
                                                    />
                                                </Col>
                                            : ""
                                        }
                                        <Col lg={4}>
                                            <Label htmlFor="tipo_solicitud" className="form-label">
                                                Tipo de solicitud
                                            </Label>
                                            <Select
                                                name="tipo_solicitud"
                                                options={tiposSolicitudes}
                                                value={tipo_solicitud}
                                                onChange={this.actualizarSelectsYDatosPorFiltros}
                                                className="basic-single"
                                                classNamePrefix="select"
                                                placeholder="Selecciona.."
                                                isClearable={true}
                                                isSearchable={true}
                                                noOptionsMessage={noMasOpciones2}
                                            />
                                        </Col>
                                        <Col lg={4}>
                                            <Label htmlFor="estado" className="form-label">
                                                Estado
                                            </Label>
                                            <Select
                                                name="estado"
                                                options={estados}
                                                value={estado}
                                                onChange={this.actualizarSelectsYDatosPorFiltros}
                                                className="basic-single"
                                                classNamePrefix="select"
                                                placeholder="Selecciona.."
                                                isClearable={true}
                                                isSearchable={true}
                                                noOptionsMessage={noMasOpciones}
                                            />
                                        </Col>
                                                                           
                                        <Col lg={4}>
                                            <Label htmlFor="lugar_ubicacion" className="form-label">
                                                Ubicación
                                            </Label>
                                            <Select
                                                name="lugar_ubicacion"
                                                options={ubicaciones}
                                                value={lugar_ubicacion}
                                                onChange={this.actualizarSelectsYDatosPorFiltros}
                                                className="basic-single"
                                                classNamePrefix="select"
                                                placeholder="Selecciona.."
                                                isClearable={true}
                                                isSearchable={true}
                                                noOptionsMessage={noMasOpciones}
                                            />
                                        </Col>
                                        <Col lg={4}>
                                            <Label htmlFor="asignado_a" className="form-label">
                                                Asignado a
                                            </Label>
                                            <Select
                                                name="asignado_a"
                                                options={asignado_a_listado}
                                                value={asignado_a}
                                                onChange={this.actualizarSelectsYDatosPorFiltros}
                                                className="basic-single"
                                                classNamePrefix="select"
                                                placeholder="Selecciona.."
                                                isClearable={true}
                                                isSearchable={true}
                                                noOptionsMessage={noMasOpciones}
                                            />
                                        </Col>                                                
                                        <Col lg={4}>
                                            <p />
                                            <MDBBtn className="waves-effect" color="info" onClick={this.filtrarBusqueda} style={{"margin-top": "12px"}}>
                                                <MDBIcon icon="fas fa-search" />{' '}
                                                BUSCAR
                                            </MDBBtn>
                                            {' '}
                                            {
                                                mostrarSpinner ?
                                                ''
                                                :
                                                <MDBBtn color="success" onClick={this.getReport} style={{"margin-top": "12px"}}>
                                                    <MDBIcon icon="fas fa-book" />{' '}
                                                    Excel
                                                </MDBBtn>
                                            }
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                            <Card>
                                <CardBody>
                                    <Container fluid>
                                        <Breadcrumbs breadcrumbItem={_valid(this.apiRest.getRol()) ?
                                            'Calendario' : 'Calendario ' + this.apiRest.getEmpresaNombre()}
                                        />
                                        <p />
                                        <Row>
                                            <Col className="col-12">
                                                {
                                                    mostrarSpinner ?
                                                        <Row>
                                                            <Col style={{ display: "flex", justifyContent: "center" }}>
                                                                <Spinner className="m-1" color="primary" />
                                                            </Col>
                                                        </Row>
                                                        :
                                                        ''
                                                }
                                                {' '}
                                                <FullCalendar
                                                    events={eventos}
                                                    plugins={[
                                                        BootstrapTheme,
                                                        dayGridPlugin,
                                                        interactionPlugin,
                                                    ]}
                                                    slotDuration={"00:15:00"}
                                                    handleWindowResize={true}
                                                    themeSystem="bootstrap"
                                                    headerToolbar={{
                                                        left: "prev,next today",
                                                        center: "title",
                                                        right: "dayGridMonth,dayGridWeek,dayGridDay",
                                                    }}
                                                    locale={esLocale}
                                                    editable={true}
                                                    droppable={true}
                                                    selectable={true}
                                                    eventClick={this.controladorClicks}
                                                    datesSet={this.actualizarFechasAlCambiarMes}
                                                />

                                                
                                            </Col>
                                        </Row>
                                    </Container>
                                </CardBody>
                            </Card>
                        </div>
                        <Card>{' '}</Card>
                        <Card>{' '}</Card>
                    </CardBody>
                </Card>
                <Modal isOpen={estadoModal} size="xl">
                    <ModalHeader toggle={this.controladorModal} tag="h4">
                        Datos de la solicitud
                    </ModalHeader>
                    <ModalBody>
                        <SolicitudInformacion props={registro.id} />
                        <ProyectoSolicitudInformacion props={registro.id} />
                    </ModalBody>
                    <ModalFooter>
                        <button
                            type="button"
                            className="btn btn-danger me-2"
                            onClick={this.controladorModal}
                        >
                            Cerrar
                        </button>
                    </ModalFooter>
                </Modal>
            </React.Fragment>
        )
    }
}